/***
 * 积木报表打印
 */
import { post, getDomain } from '../../../utils/index'
import { pgMessage } from '../../message/index'

export async function sendPrint({ compileDatas, printTemplate, getParam, url, second }) {
  const protocol = !second ? window.location.protocol : second
  for (const compile of compileDatas) {
    const param = getParam(compile)
    const _print_ = compile._print_ && compile._print_ !== 'undefined' ? compile._print_ : 1
    for (let i = 0; i < _print_; i++) {
      const [, error] = await post(
        `${protocol}//localhost:${protocol === 'http:' ? '7100' : '7101'}${url}`,
        param,
        { errorTip: null }
      )
      if (!second && error) {
        return sendPrint({
          compileDatas,
          printTemplate,
          getParam,
          url,
          second: protocol === 'http:' ? 'https:' : 'http:',
        })
      }
      if (error) {
        pgMessage.error(
          error?.msg?.config && !error?.msg?.response
            ? '打印接口无响应，请检查打印服务是否启动'
            : error?.msg
        )
        return Promise.reject(error)
      }
    }
  }
}
export async function jmreport({ compileDatas, batchPrint, printTemplate }) {
  if (!batchPrint) {
    const viewUrl = compileDatas[0].url
    window.open(viewUrl)
  } else {
    return sendPrint({
      compileDatas,
      printTemplate,
      url: '/api/jimu/print',
      getParam: (compile) => {
        return {
          Url: getDomain('/jimu/jmreport/exportPdfStream'),
          Body: JSON.stringify({
            excelConfigId: printTemplate.code,
            queryParam: {
              ...compile.urlParam,
              pageNo: '1',
              pageSize: 10,
              currentPageNo: '1',
              currentPageSize: 10,
            },
          }),
        }
      },
    })
  }
}
